import buildskillsIcon from "@/assets/icons/onboarding/goal-icon-buildskills.svg";
import discoverIcon from "@/assets/icons/onboarding/goal-icon-discover.svg";
import meaningfulcareerIcon from "@/assets/icons/onboarding/goal-icon-meaningfulcareer.svg";
import reconsiderIcon from "@/assets/icons/onboarding/goal-icon-reconsider.svg";
import stabilityIcon from "@/assets/icons/onboarding/goal-icon-stability.svg";

export const goals = [
  {
    id: 1,
    icon: discoverIcon,
    text: "Exploring careers and industries that are new to me",
    explanationHeader: "You’re not alone",
    explanationText:
      "30% of high school grads don’t yet have a chosen educational or career pathway.",
  },
  {
    id: 2,
    icon: meaningfulcareerIcon,
    text: "Finding a meaningful career that I will enjoy doing",
    explanationHeader: "You’re not alone",
    explanationText:
      "37% of Gen Z says that enjoying what you do is the most important thing about a job.",
  },
  {
    id: 3,
    icon: stabilityIcon,
    text: "Achieving financial stability and independence",
    explanationHeader: "You’re in the majority",
    explanationText:
      "55% of Gen Z says financial stability is what they most prioritize in life.",
  },
  {
    id: 4,
    icon: buildskillsIcon,
    text: "Building skills to help me advance in the workplace",
    explanationHeader: "Great choice",
    explanationText:
      "Did you know that 93% of employers say life skills play a critical role in who they hire?",
  },
  {
    id: 5,
    icon: reconsiderIcon,
    text: "Reconsidering my chosen career or education pathway",
    explanationHeader: "You’re not alone",
    explanationText:
      "37% of high school grads aren’t sure about their chosen education or career pathway.",
  },
];

export const catchphrases = [
  { id: 1, text: "Making my mark" },
  { id: 2, text: "Building my empire" },
  { id: 3, text: "Watch me work" },
  { id: 4, text: "Finding my spark" },
  { id: 5, text: "Real-world ready" },
  { id: 6, text: "None of the above" },
];

import character1 from "@/assets/illustrations/characters/avatar-option-01.svg";
import character2 from "@/assets/illustrations/characters/avatar-option-02.svg";
import character3 from "@/assets/illustrations/characters/avatar-option-03.svg";
import character4 from "@/assets/illustrations/characters/avatar-option-04.svg";
import character5 from "@/assets/illustrations/characters/avatar-option-05.svg";
import character6 from "@/assets/illustrations/characters/avatar-option-06.svg";
import character7 from "@/assets/illustrations/characters/avatar-option-07.svg";
import character8 from "@/assets/illustrations/characters/avatar-option-08.svg";

export const avatars = [
  { id: 1, src: character1 },
  { id: 2, src: character2 },
  { id: 3, src: character3 },
  { id: 4, src: character4 },
  { id: 5, src: character5 },
  { id: 6, src: character6 },
  { id: 7, src: character7 },
  { id: 8, src: character8 },
];
